const options = {
  5: "bg-neutral-900/5",
  10: "bg-neutral-900/10",
  25: "bg-neutral-900/25",
  50: "bg-neutral-900/50",
  75: "bg-neutral-900/75",
  90: "bg-neutral-900/90",
  100: "bg-neutral-900",
};

const from = {
  5: "from-neutral-900/5",
  10: "from-neutral-900/10",
  25: "from-neutral-900/25",
  50: "from-neutral-900/50",
  75: "from-neutral-900/75",
  90: "from-neutral-900/90",
  100: "from-neutral-900",
};

export default function getBackgroundNeutral900(opacity, isFrom) {
  return (isFrom ? from : options)[opacity || 100];
}
